module.exports = __webpack_public_path__ + "media/congratulations.d4576399.mp3";